module.exports = __webpack_public_path__ + "static/media/1_FR.540ee9c9.mp3";